import { Skeleton } from "@mui/material";

const MuiSkeleton = Skeleton;

export default MuiSkeleton;